(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trikolumo-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STEP = 3;

  function tkRevInit(section) {
    if (section.getAttribute('data-tk-rev-ready') === '1') return;
    section.setAttribute('data-tk-rev-ready', '1');

    var items = section.querySelectorAll('.tk-rev-item');
    var btn = section.querySelector('.tk-rev-more');
    var shown = 0;

    function reveal() {
      for (var i = shown; i < shown + STEP; i++) {
        if (items[i]) items[i].style.display = 'block';
      }
      shown += STEP;
      if (btn && shown >= items.length) btn.style.display = 'none';
    }

    reveal();
    if (btn) btn.addEventListener('click', reveal);
  }

  function tkRevBoot(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.tk-rev');
    for (var i = 0; i < sections.length; i++) tkRevInit(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tkRevBoot(); });
  } else {
    tkRevBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) tkRevBoot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
